/**
 * The phone's lock screen words (piece 35, *Face ID and the TestFlight build
 * (batch FI1)*; decision 4400): the biometric prompt, the PIN set once at
 * sign-in, the PIN that unlocks, the warnings from the third failure and the
 * notice the fifth leaves on the sign-in. Since Stage 0 (batch S0-5) the
 * warnings read the plan's own words, because the fifth failure deletes the
 * store with whatever it holds. Kept beside the other phone words and
 * spread into the one string lookup. The app's name and the sign-in's own words
 * are read from the web's keys.
 */
export const LOCK_STRINGS = {
  'mobile.lock.title': 'Locked',
  'mobile.lock.hidden': 'The app is locked.',
  'mobile.lock.prompt': 'Unlock to continue',
  'mobile.lock.usePin': 'Use PIN',
  'mobile.lock.useFaceId': 'Use Face ID',
  'mobile.lock.useFingerprint': 'Use Fingerprint',
  'mobile.lock.pin': 'PIN',
  'mobile.lock.unlock': 'Unlock',
  'mobile.lock.wrong': 'That PIN did not match.',
  'mobile.lock.remainingTwo': '2 attempts remaining. Unsynced work on this device will be lost.',
  'mobile.lock.remainingOne': '1 attempt remaining. Unsynced work on this device will be lost.',
  'mobile.lock.wait': 'Try again in',
  'mobile.lock.wiped': 'The PIN was entered wrong five times, so this phone was signed out and the records it kept were deleted. Sign in again to continue.',
  'mobile.lock.wipedPartly': 'The PIN was entered wrong five times, so this phone was signed out. Some of the records it kept could not be deleted yet, and they are deleted the next time the app opens. Sign in again to continue.',
  'mobile.lock.noPin': 'This phone has no PIN yet. Sign in again to set one.',
  'mobile.lock.setup.title': 'Set a PIN for This Phone',
  'mobile.lock.setup.hint': 'Four to six digits. It unlocks the app when Face ID or a fingerprint is not used, and it never leaves this phone.',
  'mobile.lock.setup.confirm': 'Type the PIN Again',
  'mobile.lock.setup.save': 'Set PIN',
  'mobile.lock.setup.digits': 'A PIN is four to six digits.',
  'mobile.lock.setup.mismatch': 'The two PINs do not match.',
} as const;
